export function noopReducer<T>(defaults: T) {
  return (state: T | undefined) => {
    return state || defaults;
  };
}
